// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import stylesStore from './rostelecom-styles-store';
import windowSizeStore from '../../../../services/window-size/window-size-store';
import { processStyles } from './rostelecom-styles-helper';
import Radium from 'radium';

function getTotalWidth(): number {
    return 1024;
}
function getWidthScale(): number {
    if (stylesStore.getState().disableRadiumWidthScaling) {
        return 1;
    }
    return windowSizeStore.getState().width / getTotalWidth();
}
function getHeightScale(): number {
    return 1;
}

// tslint:disable-next-line:interface-over-type-literal (autogenerated)
type TStylingParams = {
    getWidthScale?(): number;
    getHeightScale?(): number;
};

export const rostelecomRadiumStylingPlugin = (params: TStylingParams) => ({
    componentName,
    style
}) => {
    const styleStoreState = stylesStore.getState();
    styleStoreState.widthScale = params.getWidthScale ? params.getWidthScale() : getWidthScale();
    styleStoreState.heightScale = params.getHeightScale
        ? params.getHeightScale()
        : getHeightScale();
    const newStyle = processStyles(styleStoreState, style, componentName);
    return { style: newStyle };
};

export interface IRostelecomRadium {
    (component: any): any;
    getState(stateKey: any, elementKey: string, value: string): boolean;
    getWidthScale(): number;
    getHeightScale(): number;
    getTotalWidth(): number;
    // add radium api here
}

const Plugins = (Radium as any).Plugins;

export const ParametrizedRadium = (params: TStylingParams) => component => {
    return Radium({
        plugins: [
            rostelecomRadiumStylingPlugin(params),
            Plugins.mergeStyleArray,
            Plugins.checkProps,
            Plugins.resolveMediaQueries,
            Plugins.resolveInteractionStyles,
            Plugins.prefix
        ]
    })(component);
};

const RostelecomRadium: any = component => {
    return ParametrizedRadium({})(component);
};

RostelecomRadium.getState = Radium.getState;
RostelecomRadium.getWidthScale = getWidthScale;
RostelecomRadium.getHeightScale = getHeightScale;
RostelecomRadium.getTotalWidth = getTotalWidth;

// tslint:disable-next-line:no-default-export (autogenerated)
export default RostelecomRadium as IRostelecomRadium;
